import { Route } from '@angular/router';
import { pagePermissionActivate } from '../page-permission';

/** Inquiry module under `/inquiry/...` (default: `inquiry/inquiry-chat`). */
export const inquiryRoutes: Route = {
    path: 'inquiry',
    data: { title: 'inquiry' },
    children: [
        { path: '', pathMatch: 'full', redirectTo: 'inquiry-chat' },
        {
            path: 'inquiry-chat',
            loadComponent: () =>
                import('./inquiry-chat/inquiry-chat.component').then((m) => m.InquiryChatComponent),
            data: { title: 'inquiry-chat' },
        },
        {
            path: 'inquiry',
            loadComponent: () => import('./inquiry/inquiry.component').then((m) => m.InquiryComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'inquiry' },
        },
        {
            path: 'inquiry-correspondence',
            loadComponent: () =>
                import('./inquiry-correspondence/inquiry-correspondence.component').then(
                    (m) => m.InquiryCorrespondenceComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'inquiry-correspondence' },
        },
        {
            path: 'inquiry-type',
            loadComponent: () => import('./inquiry-type/inquiry-type.component').then((m) => m.InquiryTypeComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Inquiry type' },
        },
    ],
};
